import React from 'react';
import { NavCard } from '@components/simba-cards';
import { ExternalLinkType } from '@appTypes/externalLinkType';
import * as S from './ExternalLinkCard.styles';

interface Props {
  externalLink: ExternalLinkType;
}

export const ExternalLinkCard = ({ externalLink }: Props) => {
  const cardUrl = externalLink.href;

  return (
    <S.StyledA href={cardUrl}>
      <NavCard title={externalLink?.title} isInternalLink height="100%" />
    </S.StyledA>
  );
};
